import { render, staticRenderFns } from "./FloatingOfflineIndicator.vue?vue&type=template&id=189c1448&scoped=true&"
import script from "./FloatingOfflineIndicator.vue?vue&type=script&lang=js&"
export * from "./FloatingOfflineIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FloatingOfflineIndicator.vue?vue&type=style&index=0&id=189c1448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c1448",
  null
  
)

export default component.exports